import { DispatcherEvent } from '@carvana/merch-native';
import { useSubsequentEffect } from '@carvana/merch-react-hooks';
import { useContext } from 'react';
import NativeCapability from '~/constants/srp/nativeCapability';
import { useIsNativeCapabilityActive } from '~/context/common/NativeContext';
import ModalContext from '~/context/srp/ModalContext';
import sendMessageToNative from './sendMessageToNative';

export default function useFullscreenDispatcher() {
  const { isAnyModalOpen, isGeolocationModalOpen, isSoftPullModalOpen } =
    useContext(ModalContext);
  const shouldUseGeolocationWebView = useIsNativeCapabilityActive(
    NativeCapability.GeolocationWebView
  );

  const isNativeModalOpen =
    (isGeolocationModalOpen && !shouldUseGeolocationWebView) ||
    isSoftPullModalOpen;
  const isWebModalOpen = isAnyModalOpen && !isNativeModalOpen;

  useSubsequentEffect(() => {
    sendMessageToNative(
      isWebModalOpen
        ? DispatcherEvent.EnterFullscreen
        : DispatcherEvent.LeaveFullscreen,
      {}
    );
  }, [isWebModalOpen]);
}
